<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Formation</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
  
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- Product Image -->
        <vs-row>
     <vs-col vs-offset="3" v-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">    
    <vx-card>
        <img :src="dataAvatar" alt="content-img" class="responsive rounded-lg">  
        <vs-col vs-offset="3" v-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <h2 class="mt-3 mb-2">{{dataTitre}}</h2>
        </vs-col>
    </vx-card>
  </vs-col>
</vs-row>
        
        
        <div class="vx-row mt-5">
            
            <div class="vx-col w-full  mb-base mx-auto">
                <vx-card>
                    <div class="  ">
                        <div class="mb-4">Formateur:</div>
                        <div class="flex" ><div v-for="i in dataFormateur.length">
                          <vs-chip class="ml-2 " color="#24c1a0">
                            <vs-avatar :src="dataFormateur[i-1].avatar"  />{{dataFormateur[i-1].nom }}{{' '}}{{dataFormateur[i-1].prenom }}</vs-chip></div>
                    </div></div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap pl-20 pr-20">
                        <span>
                            <p class="text-xl">{{dataPrix}} DT</p>
                            <p class="text-grey">prix</p>
                        </span>
                        <span>
                            <p class="text-xl">{{datanbr_groupe}} Groupe</p>
                            
                        </span>
                        <span>
                            <p class="text-xl">{{datapartisipationtotal}}</p>
                            <p class="text-grey">participation</p>
                        </span>
                        
                    </div>
                    <vs-divider></vs-divider>
                    <p class="text-xl ml-5 mr-5 mt-2 mb-2">{{dataDescription}}</p>
                    <vs-divider></vs-divider>
                    <!--div class="vx-row">
                        <div class="vx-col w-1/2 mb-3">
                            <small>Revenu obtenu:{{(data_local.prix * 100 / data_local.prixtotal).toFixed(2)}}%</small>
                            <vs-progress class="block mt-1" :percent="data_local.prix * 100 / data_local.prixtotal" color="primary"></vs-progress>
                        </div>
                        <div class="vx-col w-1/2 mb-3">
                            <small>Salaire payé :{{(data_local.salaire_prof * 100 / data_local.salaire_proftotal).toFixed(2)}}%</small>
                            <vs-progress class="block mt-1" :percent="data_local.salaire_prof * 100 / data_local.salaire_proftotal" color="warning"></vs-progress>
                        </div>
                        <div class="vx-col w-1/2 mb-3">
                            <small>nbr participation:{{(data_local.partisipation * 100 / data_local.partisipationtotal).toFixed(2)}}%</small>
                            <vs-progress class="block mt-1" :percent="data_local.partisipation * 100 / data_local.partisipationtotal" color="danger"></vs-progress>
                        </div>
                        <div class="vx-col w-1/2 mb-3">
                            <small>Bénéfice obtenu :{{((data_local.prix * 100 / data_local.prixtotal)-(data_local.salaire_prof * 100 / data_local.salaire_proftotal)).toFixed(2)}}%</small>
                            <vs-progress class="block mt-1" :percent="(data_local.prix * 100 / data_local.prixtotal)-(data_local.salaire_prof * 100 / data_local.salaire_proftotal)" color="success"></vs-progress>
                        </div>
                    </div-->
                    
                    <vs-divider></vs-divider>
                     

                </vx-card>
            </div>

            
        </div>

        <div class="upload-img mt-5" v-if="!dataAvatar">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="inscrire" :disabled="!isFormValid">S'inscrire</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
//import axios from "../../../http/axios/index.js"
import moduledomaine from '@/store/domaine/moduledomaine.js'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
     
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        let { partisipationtotal,nbr_groupe,formateur,salaire_formateur,domaine_id,description, id, image, titre, nom_domaine, prixx } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataDescription = description
        this.dataAvatar = image
        this.dataTitre = titre
        this.dataPrix = prixx
        this.dataNom_domaine = nom_domaine
        this.dataSalaire = salaire_formateur
        this.dataDomaine = domaine_id
        this.dataFormateur = formateur
        this.datanbr_groupe = nbr_groupe
        this.datapartisipationtotal = partisipationtotal
        this.initValues()
       
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {
      datanbr_groupe: null,
      change_image: false,
      newformation: false,
      file: null, 
      dataTitre: null, 
      datadomaine: null,
      datadescription: null,
      dataprix: null,
      dataSalaire: null,
      dataNom_domaine: null,
      dataId: null,
      dataAvatar: null,
      dataOrder_status: "pending",
      dataPrice: 0,
      dataFormateur:[],
      category_choices: [],
      
      
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    domaineData() {
      return this.$store.state.domaine.users
    },
    isSidebarActiveLocal: {
      get() {
        console.log(this.isSidebarActive)
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    domaine_choices() {
        let opts=[];
          for (var domaine of this.$store.state.domaine.users) {
              opts.push({text: domaine.nom_domaine, value: domaine.id});
              
            }
            
      return opts
    },
    domaine_local: {
      get() {
        console.log(this.dataNom_domaine)
        return { text: this.dataNom_domaine,  value: this.dataDomaine  }
      },
      set(obj) {
        this.dataNom_domaine = obj.label
        this.dataDomaine = obj.value
        console.log(this.dataNom_domaine)
      }
    },
    isFormValid() {
      return !this.errors.any() 
    }
  },
  methods: {
   inscrire(){
       this.$emit('closeSidebar')
       this.$router.push('/formation/inscrie/' +this.dataId)
   },
    
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'User '+title,
                text: 'The new user was '+text
              })
            },
    
  },
  components: {
    VuePerfectScrollbar,
  },
  created() {
  if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
   this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) })


  }

    
  
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 600px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
